import { Button } from '@faxi/web-component-library';
import { Icon, InfoModal } from 'components';
import parse from 'html-react-parser';
import { FC, memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { breakTranslationNewlines } from 'utils';

import { InfoModalRef } from '../../../../../components/_molecules/InfoModal/InfoModal.component';

const LegalNoteModal: FC = () => {
  const { t } = useTranslation();

  const infoModalRef = useRef<InfoModalRef>(null);

  return (
    <InfoModal
      ref={infoModalRef}
      trigger={
        <Button
          onClick={() => infoModalRef.current?.open()}
          variant="outline"
          icon={<Icon name="circle-info" />}
          className="cedolauto-find-dealer-form__button"
        >
          {parse(t('button-open_modal_1'))}
        </Button>
      }
      title={t('legal-note-title')}
      closeButtonText={t('button-action-close')}
    >
      {parse(
        breakTranslationNewlines(
          [t('legal-note-line_1'), t('legal-note-line_2')].join('\\n\\n')
        )
      )}
    </InfoModal>
  );
};

export default memo(LegalNoteModal);
